// ##### 25-04-30 Komarov
import { Select } from 'antd';
// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  getCurrency,
  getPickedCurrencyResponse,
} from '../../../../Redux/actions';
// ##### 25-05-21 Komarov
import OptionContent from './OptionContent';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const CurrencySelect = ({ dropdownStyle = null }) => {
  // ##### 25-02-21 Komarov
  const deviceType = useSelector(state => state.deviceType);

  // ##### 24-02-22 Komarov
  const location = useLocation();
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  // ##### 22-08-29 Komarov: Добавил значение валюты по умолчанию, если оно отсутствует в path.selected_currency
  // ##### Komarov 2025-07-21
  const [currency, setCurrency] = useState(
    search_data?.selected_currency || 'UAH'
  );
  const { Option } = Select;
  // ##### Komarov 2025-07-12
  useEffect(() => {
    localStorage.setItem('current_currency', currency);
    // ##### 24-07-30 Komarov
    dispatch(getPickedCurrencyResponse(currency));
  }, [currency]);

  // ##### 24-07-25 Komarov
  const currenciesFromState = useSelector(state => state.currency.currencies);
  // ##### 25-03-05 Komarov
  /* const currencies = (currenciesFromState.length > 0 && currenciesFromState)
    || JSON.parse(localStorage.getItem("currency")).currencies; */
  const currencies = currenciesFromState.length > 0 && currenciesFromState;

  // ##### Komarov 2025-07-12
  useEffect(() => {
    currencies.length > 0 || dispatch(getCurrency());
  }, [currencies.length]);

  // ##### 24-02-22 Komarov
  const dispatch = useDispatch();
  const history = useHistory();

  // ##### 23-02-14 Komarov
  const SelectCurrency = value => {
    setCurrency(value);
    // ##### 24-02-21 Komarov
    // history.push(`/${locale}/?selected_currency=${value}`)
    history.push(
      `${location.pathname}${location.search.replace(
        search_data?.selected_currency,
        value
      )}`
    );
    // ##### 24-02-22 Komarov
    localStorage.setItem('current_currency', value);
    dispatch(getPickedCurrencyResponse(value));
  };

  return (
    <Select
      defaultValue={currency}
      dropdownStyle={dropdownStyle}
      onChange={SelectCurrency}
      bordered={true}
      // ##### 24-03-21 Komarov
      size={deviceType !== 'tablet' ? 'small' : 'middle'}
    >
      <>
        {/* ##### 25-03-06 Komarov */}
        {currencies.length > 0 &&
          currencies.map(item => {
            // ##### 22-11-14 Komarov
            return (
              <Option value={item.name} key={item.id}>
                <OptionContent item={item} />
              </Option>
            );
          })}
      </>
    </Select>
  );
};

export default CurrencySelect;
